// deps
import { isEmpty, AnalyticsContextValue } from "@swiggy-private/checkout-core";
// contexts
import { CartFlowState } from "@cart-client/contexts/CartFlowContext";
// interfaces
import { INTERNAL_CART_SOURCE } from "@cart-client/interfaces/Cart";
import { AnalyticsEventPayload } from "@swiggy-private/analytics";
// constants
import { SCREEN_NAME_CATEGORY } from "./constants";

export interface OverrideScreenNameInAnalyticsEventsPayload {
    customAnalyticsPayload?: AnalyticsEventPayload;
}

export const overrideScreenNameInAnalyticsEvents = (
    analyticsContextValue: AnalyticsContextValue,
    { customAnalyticsPayload }: OverrideScreenNameInAnalyticsEventsPayload,
) => {
    if (isEmpty(customAnalyticsPayload)) {
        return analyticsContextValue;
    }

    return {
        ...analyticsContextValue,
        screenViewEvent: (payload: AnalyticsEventPayload) => {
            return analyticsContextValue.screenViewEvent({
                ...(payload ?? {}),
                ...customAnalyticsPayload,
            });
        },
        clickEvent: (payload: AnalyticsEventPayload) => {
            return analyticsContextValue.clickEvent({
                ...(payload ?? {}),
                ...customAnalyticsPayload,
            });
        },
        impressionEvent: (payload: AnalyticsEventPayload) => {
            return analyticsContextValue.impressionEvent({
                ...(payload ?? {}),
                ...customAnalyticsPayload,
            });
        },
    };
};

export const getCustomAnalyticsPayloadBasedOnCartSource = (cartSource: CartFlowState["cartSource"]) => {
    switch (cartSource) {
        case INTERNAL_CART_SOURCE.GIFTING:
            return {
                category: SCREEN_NAME_CATEGORY.GIFTING,
            };
        default:
            return {};
    }
};
